export default __webpack_public_path__ + "static/media/logo.a3f91005.png";